import { Facet } from "@linkfluence/models/facet";
import { Timezone } from "@linkfluence/models/timezone";
import { Card } from "../cards";
import { Clause } from "../clause";

export enum Layout {
  Row_1 = "row_1",
  Row_2 = "row_2",
  Row_3 = "row_3",
  Row_1_2 = "row_1_2",
  Row_2_1 = "row_2_1",
}

interface CardRowLayout<L extends Layout, K extends Card[]> {
  type: "card";
  layout: L;
  cards: K;
}

export type AlgoFieldId =
  | "volumechange_up"
  | "volumechange_down"
  | "viraposts_top"
  | "significance_keyphrase"
  | "significance_hashtag"
  | "significance_emotion"
  | "significance_affect"
  | "significance_content"
  | "significance_negative"
  | "significance_positive";

export interface TitleRow {
  dynamicTitles?: DynamicTitle[];
  icon?: AlgoFieldId;
  layout: Layout;
  style: "h1" | "h2" | "text";
  titles: string[];
  type: "title";
}

export interface PlaceHolderRow {
  type: "placeholder";
  field: string;
}

export type CardRow =
  | CardRowLayout<Layout.Row_1, [Card]>
  | CardRowLayout<Layout.Row_3, [Card, Card, Card]>
  | CardRowLayout<Layout.Row_2 | Layout.Row_2_1 | Layout.Row_1_2, [Card, Card]>;

export type Row = TitleRow | CardRow | PlaceHolderRow;

// export type WizardRow = TitleRow | CardRow | PlaceHolderRow;

export enum InsightPageAccess {
  Public = "public",
  ReadOnly = "read-only",
  Private = "private",
}

export interface InsightPageSnapshotFactory {
  emailText: string;
  filters: Clause;
  page: InsightPage;
  sendTo: string[];
}

export interface InsightPageSnapshot {
  created: number;
  customPageId: string;
  dashboardId: number;
  id: number;
  projectId: number;
  s3Id: string;
  userId: number;
}

export enum SnapshotFrequency {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Quaterly = "quarterly",
}

export interface RecurringSnapshotPayload {
  id?: number;
  emailText: string;
  filters: Clause;
  title: string;
  sendTo: string[];
  frequency: SnapshotFrequency;
  sendHour: number;
  sendMinutes: number;
  sendDay: number;
  delayStart: boolean;
  stopReportAtEnd: boolean;
  page?: Omit<InsightPage, "id">;
}

export interface InsightPageRecurringSnapshot extends RecurringSnapshotPayload {
  customPageId: string;
  author: string;
  projectId: number;
  dashboardId: number;
  filterId: string;
  created: number;
  s3Ids: string[];
  id: number;
  timezone?: Timezone;
}

export interface EmailSnapshot {
  emailText: string;
  title: string;
  sendTo: string[];
}

export interface InsightPage {
  id: string;
  title: string;
  author: number;
  projectId: number;
  dashboardId: number;
  timezone: Timezone;
  access: InsightPageAccess;
  color: string;
  description: string;
  aiContext: string;
  picture: string;
  rows: Row[];
  filters: {
    static: Facet[];
    dynamic: boolean;
  };
  periodSelector: boolean;
  sharedWith: string[];
}

export interface DynamicTitle {
  key: string;
  params: Record<string, string>;
}

export type LeanInsightPage = {
  id: string;
  title: string;
  access: InsightPageAccess;
  author: number;
  projectId: number;
  dashboardId: number;
  cardsRows: number;
};
